var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgradeModalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 11,
    fill: "#7F48FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 32V27M14.5 17V12M12 14.5H17M12 29.5H17M23 13L21.2658 17.5089C20.9838 18.2421 20.8428 18.6087 20.6235 18.9171C20.4292 19.1904 20.1904 19.4292 19.9171 19.6235C19.6087 19.8428 19.2421 19.9838 18.5089 20.2658L14 22L18.5089 23.7342C19.2421 24.0162 19.6087 24.1572 19.9171 24.3765C20.1904 24.5708 20.4292 24.8096 20.6235 25.0829C20.8428 25.3913 20.9838 25.7579 21.2658 26.4911L23 31L24.7342 26.4911C25.0162 25.7579 25.1572 25.3913 25.3765 25.0829C25.5708 24.8096 25.8096 24.5708 26.0829 24.3765C26.3913 24.1572 26.7579 24.0162 27.4911 23.7342L32 22L27.4911 20.2658C26.7579 19.9838 26.3913 19.8428 26.0829 19.6235C25.8096 19.4292 25.5708 19.1904 25.3765 18.9171C25.1572 18.6087 25.0162 18.2421 24.7342 17.5089L23 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeModalIcon);
export default __webpack_public_path__ + "static/media/upgrade-modal-icon.52a520e3eb6bb689f70ef64fe927d8f1.svg";
export { ForwardRef as ReactComponent };